<div class="address-main-wrapper">
  <form [formGroup]="billingAddressForm" (ngSubmit)="onSubmitBilling()">
    <div class="form-box">
      <div class="address-form-wrapper">
        <div class="form-wrapper">
          <label for="">Address<span class="red">*</span></label>
          <mat-form-field>
            <textarea
              matInput
              placeholder="Street 1"
              formControlName="address"
            ></textarea>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  billingAddressForm.get('address')!.touched &&
                  billingAddressForm.get('address')!.hasError('required')
                "
                >Address is required.</mat-error
              >
            </span>
          </div> 
        </div>
        <div class="form-wrapper">
          <label for="">Country</label>
          <mat-form-field>
            <mat-select placeholder="Select country" formControlName="country">
              @for (country of countries; track country) {
              <mat-option [value]="country.name">{{ country.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-wrapper">
          <label for="">City</label>
          <mat-form-field>
            <input matInput placeholder="Enter city" formControlName="city" />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  billingAddressForm.get('city')!.touched &&
                  billingAddressForm.get('city')!.hasError('maxlength')
                "
                >City name must be at most 10 characters long.</mat-error
              >
            </span>
          </div>
        </div>
        <div class="form-wrapper">
          <label for="">State</label>
          <mat-form-field>
            <input matInput placeholder="Enter state" formControlName="state" />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  billingAddressForm.get('state')!.touched &&
                  billingAddressForm.get('state')!.hasError('maxlength')
                "
                >State name must be at most 10 characters long.</mat-error
              >
            </span>
          </div>
        </div>
        <div class="form-wrapper">
          <label for="">ZIP Code</label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter number"
              formControlName="pinCode"
            />
            <!-- Max Length Error - only if value exceeds maximum length -->
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  billingAddressForm.get('pinCode')!.touched &&
                  billingAddressForm.get('pinCode')!.hasError('maxlength')
                "
                >ZIP code must be at most 8 characters long.</mat-error
              >
            </span>
            <span>
              <mat-error
                *ngIf="
                  billingAddressForm.get('pinCode')!.touched &&
                  billingAddressForm.get('pinCode')!.hasError('pattern')
                "
                >Invalid ZIP code number. Only digits are allowed.</mat-error
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
